var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var SvgImage = function SvgImage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5543 7.42736L23.0251 1.16436C22.3248 0.492524 21.3754 0.111816 20.387 0.111816H4.50393C2.44169 0.119281 0.768555 1.72422 0.768555 3.70241V34.7562C0.768555 36.7343 2.44169 38.3393 4.50393 38.3393H26.9162C28.9784 38.3393 30.6515 36.7343 30.6515 34.7562V9.96541C30.6515 9.01738 30.2546 8.0992 29.5543 7.42736ZM26.6127 9.67428H20.6905V3.99354L26.6127 9.67428ZM4.50393 34.7562V3.70241H16.9552V11.4658C16.9552 12.4587 17.7878 13.2574 18.8229 13.2574H26.9162V34.7562H4.50393ZM6.99417 31.173H24.4259V21.618L22.5971 19.8638C22.2314 19.5129 21.6399 19.5129 21.2742 19.8638L14.4649 26.3955L11.391 23.4469C11.0253 23.0961 10.4338 23.0961 10.0681 23.4469L6.99417 26.3955V31.173ZM10.7295 13.2574C8.66731 13.2574 6.99417 14.8624 6.99417 16.8405C6.99417 18.8187 8.66731 20.4237 10.7295 20.4237C12.7918 20.4237 14.4649 18.8187 14.4649 16.8405C14.4649 14.8624 12.7918 13.2574 10.7295 13.2574Z",
    fill: "#4004A3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image.b2a7adb9.svg";
export { ForwardRef as ReactComponent };